import React, { useEffect, useRef, useState } from "react"
import { Accordion } from "react-bootstrap"
import CustomerInfo from "../../../../components/CustomerInfo/customerInfo"
import LoadingSpinner from "../../../../components/Loading/LoadingSpinner"
import CustomerAccordion from "../../../../components/Selection/CustomerAccordion"
import { getAllCustomerInfo, createUser } from "../../../../firestore/firestore"
import { createAccountWithoutSignIn } from "../../../../auth/auth"
import PullToRefresh from "react-simple-pull-to-refresh"
import { sortArrayOfObjects } from "../../../../util/helper"
import AddUserModal from "../../../../components/Modals/AddUserModal"
import "../employees/employees.css"

export default function Customers() {
  const [customers, setCustomers] = useState("")
  const [currentTarget, setCurrentTarget] = useState(null)
  const [showAddModal, setShowAddModal] = useState(false)
  const accordionRef = useRef()

  useEffect(() => {
    handleRefresh()
  }, [])

  useEffect(() => {
    if (!currentTarget) {
      return
    }
    accordionRef.current = currentTarget

    setTimeout(
      () =>
        accordionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        }),
      200
    )
  }, [currentTarget])

  async function handleRefresh() {
    const getCustomerData = async () => {
      const customerData = await getAllCustomerInfo()
      const sortedCustomerData = customerData.sort((a, b) => sortArrayOfObjects(a.lastName, b.lastName))
      setCustomers([])
      // setCustomers(sortedCustomerData)
      //force page to refresh even if data is the same
      return sortedCustomerData
    }
    getCustomerData().then((results) => setCustomers(results)).catch((err) => console.log(err))
  }

  function handleAccordion(e) {
    const element = e.currentTarget
    setCurrentTarget((prevTarget) => (prevTarget = element))
  }

  async function handleAddCustomer(formData) {
    try {
      const user = await createAccountWithoutSignIn(formData.email, formData.password)
      const userData = {
        id: user.uid,
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: formData.firstName + " " + formData.lastName,
        email: formData.email,
        role: "customer",
        imgUrl: "",
        mobile: formData.mobile,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipcode: formData.zipcode,
        plants: [],
        messages: [],
        active: true,
      }
      await createUser(userData)
      alert(`Customer ${userData.fullName} created successfully.`)
      setShowAddModal(false)
      handleRefresh()
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        alert("This email is already registered.")
      } else {
        alert("Error creating customer: " + err.message)
      }
      throw err
    }
  }

  if (customers) {
    return (
      <>
        <PullToRefresh onRefresh={handleRefresh} pullDownThreshold={90} resistance={3}>
          <Accordion className="custom-accordion">
            {customers.map((customer, i) => {
              return (
                <div key={i + customer.id} ref={accordionRef} onClick={handleAccordion}>
                  {/* Create accordian item with plant offerings. */}
                  <CustomerAccordion eventKey={i} customer={customer} id={i + customer.id} refreshCallback={handleRefresh}>
                    <CustomerInfo customer={customer} i={i} refreshCallback={handleRefresh} />
                  </CustomerAccordion>
                </div>
              )
            })}
          </Accordion>
          <div className="add-btn-container">
            <button className="btn-add" onClick={() => setShowAddModal(true)}>
              Add Customer
            </button>
          </div>
          <AddUserModal show={showAddModal} onClose={() => setShowAddModal(false)} onSubmit={handleAddCustomer} role="customer" />
        </PullToRefresh>
      </>
    )
  } else {
    return <LoadingSpinner />
  }
}
